export const EmailIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_52677)">
        <path
          d="M3.13281 4.375H18.1328V15C18.1328 15.1658 18.067 15.3247 17.9498 15.4419C17.8325 15.5592 17.6736 15.625 17.5078 15.625H3.75781C3.59205 15.625 3.43308 15.5592 3.31587 15.4419C3.19866 15.3247 3.13281 15.1658 3.13281 15V4.375Z"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1328 4.375L10.6328 11.25L3.13281 4.375"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1742_52677">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.632812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
